import styled from 'styled-components';

export const TotalCardHeader = styled.div`
  width: 100%;
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  text-align: center;
  p {
    padding: 5px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;
